/* @flow */
import * as React from 'react';
import { inject, observer } from 'mobx-react';
import Button from '@material-ui/core/Button';
import { Trans, translate } from 'react-i18next';
import type { TranslatorProps } from 'react-i18next';
import { ComponentWithInjectedProps } from 'utils/injectedProps';
import type TypeActionDrawerStore from 'stores/ActionDrawerStore';
import styles from '../../../../ActionDrawer.module.scss';
import type { AssignOrChangeUserLocationProps } from '../DeleteUserLocation';

type InjectedProps = {|
  actionDrawerStore: TypeActionDrawerStore,
|} & TranslatorProps;

@translate()
@inject('actionDrawerStore')
@observer
export default class DeleteUserLocationError extends ComponentWithInjectedProps<
  AssignOrChangeUserLocationProps,
  {},
  InjectedProps
> {
  render() {
    const { t, actionDrawerStore } = this.props;

    return (
      <React.Fragment>
        <div className={styles['action-drawer-content']}>
          <h3>{t('general:error')}</h3>
        </div>
        <div className={styles['action-drawer-actions']}>
          <Button
            color="primary"
            variant="contained"
            onClick={() => actionDrawerStore.closeActionDrawer()}
          >
            {t('general:actions.close')}
          </Button>
        </div>
      </React.Fragment>
    );
  }
}
